export const reportTotalStyle = {
    minWidth: "10rem",
    maxWidth: "10rem",
    position: "sticky",
    left: "10rem",
    top: "0",
    backgroundColor: "#C7D2E1",
  };
   export const reportTotalStyleFirst = {
    minWidth: "10rem",
    maxWidth: "10rem",
    position: "sticky",
    left: "10rem",
    top: "0",
    backgroundColor: "#C7D2E1",
    zIndex: "999",
  };
   export const reportStyle = {
    minWidth: "10rem",
    maxWidth: "10rem",
    position: "sticky",
    left: "0",
    top: "0",
    backgroundColor: "#C7D2E1",
  };
   export const reportStyleFirst = {
    minWidth: "10rem",
    maxWidth: "10rem",
    position: "sticky",
    left: "0",
    top: "0",
    backgroundColor: "#C7D2E1",
    zIndex: "999",
  };
   export const column = {
    minWidth: "10rem",
    maxHeight: "10rem",
    position: "sticky",
    top: "0",
    backgroundColor: "#C7D2E1",
  };